export const COMPANY_NAME = 'ООО «МЕДРОКЕТ»'

export const COMPANY_NAME_SHORT = 'МЕДРОКЕТ'

export const COMPANY_NAME_CIS = `${COMPANY_NAME} (Филиал общества с ограниченной ответственностью «${COMPANY_NAME_SHORT}» (Российская Федерация))`

export const COMPANY_NAME_KZ = `${COMPANY_NAME} (Филиал ${COMPANY_NAME} в Республике Казахстан)`
export const COMPANY_NAME_KG = `${COMPANY_NAME} (Филиал ${COMPANY_NAME} в Республике Кыргызстан)`
